export default {
    unit: 8
}


// WEBPACK FOOTER //
// ./src/theme/spacing.js